import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useHistorial } from '../../hooks/useManifest';
import ManifestHistory from '../../components/administracion/ManifestHistory';
import { useParams } from "react-router-dom";

const ManifiestoHistorialPage = () => {
    const { manifestId } = useParams();    
    const { historial, isLoading, error } = useHistorial(manifestId);

    if (isLoading) return <CircularProgress />;
    if (error) return <Alert severity="error">Error al cargar historial del manifiesto.</Alert>;

    return (
        <Box sx={{ p: 2 }}>
            <ManifestHistory
                windows={historial}
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de manifiesto detalle:', newOrder);
                }}
            />
        </Box>
    );
};

export default ManifiestoHistorialPage;